import _ from 'lodash';
import React, { useContext, useCallback } from 'react';
import { wizardProps, WizardPage } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { useDependencies } from '@xengage/gw-portals-dependency-react';
import presentationMetadata from './InfoPage.metadata.json5';
import './InfoPage.messages';
import { BreakpointTrackerContext } from '@jutro/legacy/layout';

function YourInfoPage(props) {
    const { isComponentValid, initialValidation, onValidate } = useValidation('QualificationPage');
    const { LoadSaveService } = useDependencies('LoadSaveService');

    const {
        wizardData: submissionVM,
        updateWizardData,
        currentStep,
        disableNext,
        overrideProps,
        callbackMap
    } = props;

    const { pageKey } = currentStep;
    const metadata = presentationMetadata[pageKey];
    const breakpoint = useContext(BreakpointTrackerContext);

    const onNext = useCallback(
        async () => {
            submissionVM.value = await LoadSaveService
                .updateDraftSubmissionAndPrimaryLocation(submissionVM.value);
            return submissionVM;
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [submissionVM]
    );

    const overrides = _.merge({
        '@field': {
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top',
            showOptional: true
        }
    }, overrideProps);

    const resolveCallbackMap = {
        ...callbackMap,
        onValidate: onValidate
    };

    return (
        <WizardPage
            skipWhen={() => initialValidation}
            disableNext={disableNext || !isComponentValid}
            onNext={onNext}
        >
            <ViewModelForm
                uiProps={metadata.content}
                model={submissionVM}
                overrideProps={overrides}
                onModelChange={updateWizardData}
                callbackMap={resolveCallbackMap}
                onValidationChange={onValidate}
            />
        </WizardPage>
    );
}

YourInfoPage.propTypes = wizardProps;
export default YourInfoPage;
